/**
 * APIL Url: ADAC.Internet.Core.Models.Fahrzeugdaten.GarageType
 * Fahrzeugtypen, Werte: Sonstige = 0; Pkw = 1; Motorrad = 2; Anhaenger = 3; 
 */
export enum GarageTypeApi {
	Sonstige = 0,  // Sonstige
	Pkw = 1,  // Pkw
	Motorrad = 2,  // Motorrad
	Anhaenger = 3  // Anhaenger
};